import React, {useContext, useState, useEffect} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import './GalleryOfProperty.scss';
import GalleryMapper from "../../components/gallery-mapper/GalleryMapper"

import CrusadeBtn from '../../components/crusade/CrusadeBtn';
import { MainContext } from '../../contexts/MainContext';
import Loader from '../../components/loader-spinner/Loader';

export default function GalleryOfProperty(){
  const [isLoading, setIsLoading] = useState(true);
  const { cityName, communityName, propertyName } = useParams();

  const location = useLocation();

  const {
    allProperties,
    allGroups
  } = useContext(MainContext);

  const communityProperties = allProperties.filter(
    (property) => 
      property.path?.startsWith(`/${cityName}/${communityName}/`) &&
      (property.enabled === undefined || property.enabled === true)
  );

  const communityGroupMarkersProperties = allGroups.map(element => element.modal_map_coords_pin.filter( (property) => property.path.startsWith(`/${cityName}/${communityName}/${propertyName}`))).flat();


  const communityMarkers = [ ...communityProperties, ...communityGroupMarkersProperties ];

  const getPropertyLogo = () => {
    const currentPath = location.pathname.replace("/gallery", "");
    const property = communityMarkers.find(item => item.path === currentPath);
    return property?.logo;
  };

  return (
    <div className="gallery-container">
      {getPropertyLogo() ? (
            <img
                className="property-logo"
                src={getPropertyLogo()}
                alt="Property Logo"
            />
        ) : (
            <div className="property-logo-text">Ellington</div>
        )}
      <CrusadeBtn />
      <GalleryMapper onLoadComplete={() => setIsLoading(false)}/>
      <Loader isVisible={isLoading} />
    </div>
  );
};
